var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"em-btn",class:{ primary: _vm.primary, selected: _vm.selected },on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[_vm._v(" "+_vm._s(_vm.text)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }